import type { FormAnswers } from '../types';

const ANSWERS_KEY = 'hit_application_answers';
const STEP_KEY = 'hit_application_current_step';

export function useFormPersistence() {
  const loadAnswers = (): FormAnswers => {
    try {
      const stored = localStorage.getItem(ANSWERS_KEY);
      return stored ? (JSON.parse(stored) as FormAnswers) : {};
    } catch {
      return {};
    }
  };

  const loadStep = (): number => {
    try {
      const stored = localStorage.getItem(STEP_KEY);
      return stored ? Number(stored) : 0;
    } catch {
      return 0;
    }
  };

  const saveAnswers = (answers: FormAnswers): void => {
    localStorage.setItem(ANSWERS_KEY, JSON.stringify(answers));
  };

  const saveStep = (step: number): void => {
    localStorage.setItem(STEP_KEY, String(step));
  };

  const clearAll = (): void => {
    localStorage.removeItem(ANSWERS_KEY);
    localStorage.removeItem(STEP_KEY);
  };

  return { loadAnswers, loadStep, saveAnswers, saveStep, clearAll };
}
